module.exports = __webpack_public_path__ + "static/media/luggers-with-items-and-xl.eb4e5c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/luggers-with-items-and-xl.png
// module id = 1213
// module chunks = 27